import { render, staticRenderFns } from "./SkuList.vue?vue&type=template&id=f039e14a"
import script from "./SkuList.vue?vue&type=script&lang=js"
export * from "./SkuList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f039e14a')) {
      api.createRecord('f039e14a', component.options)
    } else {
      api.reload('f039e14a', component.options)
    }
    module.hot.accept("./SkuList.vue?vue&type=template&id=f039e14a", function () {
      api.rerender('f039e14a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/csgOrder/internal/components/GoodsInfoTab/SkuList.vue"
export default component.exports